import React, { useState, useRef, useEffect } from 'react'

import Modal from 'components/Modal/Modal'

import AnalyticsMonitor from 'common/services/AnalyticsMonitor'

import { EDUCATION_GROUP_ID } from 'common/constants/ProductConstants'

import TopBar from './components/TopBar/TopBar'
import Counter from './components/Counter/Counter'

import WhatInteractyIsTab from './tabs/WhatInteractyIs/WhatInteractyIs'
import BasicsTab from './tabs/Basics/Basics'
import WhatIsNextTab from './tabs/WhatIsNext/WhatIsNext'

import { TABS_ENUM, TABS } from './constants'

import styles from './OnboardingModal.module.scss'

const OnboardingModal = ({ onClose }) => {
    const [activeTab, setActiveTab] = useState(TABS_ENUM.WHY_INTERACTY_TAB)
    const [isLastTabActive, setIsLastTabActive] = useState(false)
    const contentRef = useRef(null)

    useEffect(() => {
        setIsLastTabActive(activeTab === Object.keys(TABS_ENUM).length)
    }, [activeTab])

    const onNextOrFinish = (isFeedback = false) => {
        if (!!TABS[activeTab].onRead) TABS[activeTab].onRead()
        if (isLastTabActive) {
            if (isFeedback) AnalyticsMonitor.track('Onboarding close by feedback')
            else AnalyticsMonitor.track('Onboarding close by button')
            onClose()
            return
        }
        setActiveTab(activeTab + 1)
        contentRef.current.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })
    }

    const onFeedback = isPositive => {
        if (isPositive) AnalyticsMonitor.track('Onboarding positive feedback', { group: EDUCATION_GROUP_ID })
        else AnalyticsMonitor.track('Onboarding negative feedback', { group: EDUCATION_GROUP_ID })
        onNextOrFinish(true)
    }

    return (
        <Modal ref={contentRef}>
            <div className={styles.onboardingModal}>
                <TopBar
                    title={TABS[activeTab].title}
                    currentTabNumber={activeTab}
                    allTabsNumber={Object.keys(TABS_ENUM).length}
                    onButtonClick={() => onNextOrFinish()}
                />
                <div className={styles.content}>
                    {activeTab === TABS_ENUM.WHY_INTERACTY_TAB && <WhatInteractyIsTab />}
                    {activeTab === TABS_ENUM.BASICS_TAB && <BasicsTab />}
                    {activeTab === TABS_ENUM.WHAT_IS_NEXT_TAB && (
                        <WhatIsNextTab onFeedback={isPositive => onFeedback(isPositive)} />
                    )}
                    <Counter
                        current={activeTab}
                        all={Object.keys(TABS_ENUM).length}
                        className={styles.counter}
                        onButtonClick={() => onNextOrFinish()}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default OnboardingModal
